import Vue from "vue";
import VueTrumbowyg from "vue-trumbowyg";
import "trumbowyg/dist/ui/trumbowyg.min.css";
import "trumbowyg/plugins/fontsize/trumbowyg.fontsize";
import "trumbowyg/plugins/colors/trumbowyg.colors";
import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css";

Vue.use(VueTrumbowyg);
